import { Moment } from 'moment';

export abstract class ItemActionBase {
    protected constructor(
        public readonly id: string,
        public readonly actionSeason: string,
        public readonly status: string,
        public readonly note: string,
        public readonly purchaseDate: string,
        //public readonly purchaseDate: Moment,
        public readonly startDate: string,
        //public readonly startDate: Moment,
        public readonly endDate: string,
        //public readonly endDate: Moment,
        public readonly saleChangeRatio: string/*number*/,
        public readonly saleIncrease: string/*number*/,
        public readonly replenishment: string,
        public readonly actionOut: string,
        public readonly importDate: string,
        //public readonly importDate: Moment,
        public readonly documentNumber: string) {

    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-actions/item-action-base.ts